export default __webpack_public_path__ + "static/media/thirt.db77d94f.jpg";